export const DEFAULT_MAX_WEEK_PER_SERVICE = 5

export const LEAD_SETTINGS_PER_ACCOUNT = 'per_account'
export const LEAD_SETTINGS_PER_SERVICE = 'per_service'

export type LeadSettingsType = typeof LEAD_SETTINGS_PER_ACCOUNT | typeof LEAD_SETTINGS_PER_SERVICE

export interface LeadSettings {
    setting_id: number
    service_provider_id: number
    lead_settings_type: LeadSettingsType
    max_month: number
    max_week: number
    max_day: number
    day_limit_reached: string | null
    week_limit_reached: string | null
    month_limit_reached: string | null
    extended_match_details: boolean
    signing_date: string | null
    cancel_signing_date: string | null
    pitched_at: string | null
    unsubscribed: string | null
    charge_website_clicks: boolean
    charge_phone_calls: boolean
    manual_pause: string | null
    manual_pause_reason: number | null
    free_month_limit_reached: string | null
    website_clicks_max_week: number
    website_clicks_weekly_limit_reached: string | null
    disabled_overdue_invoices: string | null
    is_reclaiming_enabled: boolean
    /** Per-supplier opt-out for appointment scheduling; defaults to enabled. */
    is_appointments_enabled: boolean
    /** Whether the provider offers Trustoo Guaranteed; only eligible providers can switch it on. */
    guarantee_enabled: boolean
    credit_limit_reached: string | null
}

/**
 * The replacement leads of the current week, counted live off the reclaims.
 *
 * "This week" means usable in it rather than granted in it: an entitlement survives two full weeks,
 * so a reclaim approved two weeks ago still counts towards what is given this week.
 */
export interface ReplacementLeadsThisWeek {
    /** Replacement leads already delivered this week. */
    filled: number
    /**
     * Every replacement lead this week gives on top of the week limit, delivered ones included.
     * Deliberately not the open balance: it does not drop when one is delivered.
     */
    given: number
    filledPerSubscription: Record<number, number>
    givenPerSubscription: Record<number, number>
}
